import { render, staticRenderFns } from "./json-source.vue?vue&type=template&id=cdf8dd4a&"
import script from "./json-source.vue?vue&type=script&lang=js&"
export * from "./json-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports